import { firestoreAction } from 'vuexfire'
import { db } from '@/config/firebase'

const backgrounds = {
  namespaced: true,
  state: {
    backgrounds: []
  },
  actions: {
    bindRef: firestoreAction((context, deviceId) => {
      return context.bindFirestoreRef(
        'backgrounds',
        db
          .collection('devices')
          .doc(deviceId)
          .collection('backgrounds')
          .orderBy('timestamp', 'asc')
      )
    })
  },
  getters: {
    getBackgrounds: state => state.backgrounds
  }
}

export default backgrounds
